import React from 'react'
import { connect } from 'react-redux'
import FlowView from 'components/core/FlowView'
import { ContentHeader } from 'components/basic'
import { TicketCreator } from 'projects/access-gui/components'

class TicketCreate extends FlowView {
  constructor (props) {
    super(props, 'Create Ticket')
  }

  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Tickets' />
        <hr />
        <div className='row'>
          <TicketCreator {...this.props} />
        </div>
      </div>
    )
  }
}
//eslint-disable-next-line
TicketCreate = connect(state => state.siteReducer)(TicketCreate)
export default TicketCreate



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/ticket/create.js